import React, { useEffect, useState } from 'react';
import { Alert, CircularProgress, List, ListItemButton, ListItemText } from '@mui/material';

import { closeCurrentPopup, Dialog } from '@paragon/popup-state';

import { loadScheduleLineGroupData, loadScheduleLineGroupsForActiveStation } from '../../store/actions/loadActions';
import { setActiveScheduleLineGroupGuid } from '../../store/slices/productionModelsSlice';
import { useAppDispatch, useAppSelector } from '../hooks';

export function SelectScheduleLineGroupDialog() {
  const dispatch = useAppDispatch();
  const activeScheduleLineGroupGuid = useAppSelector((state) => state.productionModels.activeScheduleLineGroupGuid);
  const orderedScheduleLineGroups = useAppSelector((state) => state.productionModels.orderedScheduleLineGroups);

  const [loadingScheduleLineGroups, setLoadingScheduleLineGroups] = useState<boolean>(false);

  // Every time this dialog comes up, reload the active schedule line groups in case the schedule has changed
  useEffect(() => {
    setLoadingScheduleLineGroups(true);
    dispatch(loadScheduleLineGroupsForActiveStation()).then(() => void setLoadingScheduleLineGroups(false));
  }, [dispatch]);

  return (
    <Dialog insistent title="Schedule Line Group Selection" submitText="Close">
      {loadingScheduleLineGroups ? (
        <CircularProgress />
      ) : orderedScheduleLineGroups.length === 0 ? (
        <Alert severity="warning">
          No Schedule Line Groups are available. Contact your production supervisor to have one scheduled to your line.
        </Alert>
      ) : (
        <List>
          {orderedScheduleLineGroups.map((scheduleLineGroup) => (
            <ListItemButton
              key={scheduleLineGroup.guid}
              selected={scheduleLineGroup.guid === activeScheduleLineGroupGuid}
              onClick={() => {
                dispatch(setActiveScheduleLineGroupGuid(scheduleLineGroup.guid));
                dispatch(loadScheduleLineGroupData(scheduleLineGroup));
                dispatch(closeCurrentPopup());
              }}
            >
              <ListItemText primary={scheduleLineGroup.name} />
            </ListItemButton>
          ))}
        </List>
      )}
    </Dialog>
  );
}
